const TRANSACTION_TYPE_LABELS = {
  PAYMENT: "תשלום",
  CHARGE: "חיוב",
  REFUND: "זיכוי",
};

export const extractTransactionType = (tx) => {
  if (!tx || typeof tx !== "object") return "";
  const raw = tx.transactionType ?? tx.transaction_type ?? "";
  return String(raw).trim().toUpperCase();
};

export const getTransactionTypeText = (type) => {
  const key = String(type ?? "")
    .trim()
    .toUpperCase();
  if (!key) return "";
  return TRANSACTION_TYPE_LABELS[key] || key;
};

export const getTransactionTypeCssClass = (type) => {
  const key = String(type ?? "")
    .trim()
    .toLowerCase();
  if (key === "payment") return "payment";
  if (key === "charge") return "charge";
  if (key === "refund") return "refund";
  return "default";
};
